module.exports = __webpack_public_path__ + "static/media/14UNEP17.1c562020.jpg";